import * as angular from "angular";
import * as _ from "lodash";
import {getMetersPerLargeDistanceUnit} from "../utils/distance-unit.util";


angular
  .module('bringoz.admin.commons')
  .filter('bringozDistance', bringozDistance);

function bringozDistance(splitService, $filter) {

  const distanceConfig = splitService.getSiteDistanceLargeUnit(true),
    metersPerUnit = getMetersPerLargeDistanceUnit(distanceConfig === 'MI');

  return function bringozDistanceFilter(distanceInMeters, defaultValue, decimals = 1) {

    if(!_.isUndefined(distanceInMeters)) {
      return (distanceInMeters / metersPerUnit).toFixed(decimals).toString() + ' ' + $filter('translate')(distanceConfig);
    }else {
      return  defaultValue || '---';
    }
  }
}
